import TeamConfirmationContainer from './TeamConfirmationContainer';

export default TeamConfirmationContainer;
